__webpack_public_path__ = `${window.PUBLIC_ROOT ?? ""}${
              window.PUBLIC_ROOT_WITH_VERSION
                ? "bricks/presentational-bricks/1.339.7/dist/"
                : "bricks/presentational-bricks/dist/"
            }`;